import { render, staticRenderFns } from "./ItemSheet.vue?vue&type=template&id=46b5f996"
import script from "./ItemSheet.vue?vue&type=script&lang=js"
export * from "./ItemSheet.vue?vue&type=script&lang=js"
import style0 from "./ItemSheet.vue?vue&type=style&index=0&id=46b5f996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports